import styled, { css } from 'styled-components'
import { buttonReset } from '@/shared/styles/mixins'

interface ButtonsContinuesWrapperProps {
  $withWhatsapp?: boolean
}

export const Root = styled.div`
  ${({ theme }) => css`
    @media screen and (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `}
`

export const Content = styled.div`
  ${({ theme }) => css`
    max-width: 603px;
    width: calc(100vw - 40px);

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      text-align: left;
    }
  `}
`

export const ButtonsContinuesWrapper = styled.div<ButtonsContinuesWrapperProps>`
  ${({ theme, $withWhatsapp }) => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1.5rem;
    width: 100%;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      width: ${$withWhatsapp ? '100%' : '285px'};
      flex-direction: row;
      gap: 2rem;
    }
  `}
`

export const WrapperButtons = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr;
    width: 100%;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      grid-template-columns: repeat(2, minmax(285px, 1fr));
      gap: 2rem;
    }
  `}
`

export const WrapperUnitsNearby = styled.div`
  ${({ theme }) => css`
    margin-top: 1.5rem;
    padding: 1rem 0;

    display: flex;

    align-items: stretch;

    max-width: 604px;

    background-color: ${theme.colors.getColor('neutral-purewhite')};

    border-bottom: 4px solid ${theme.colors.getColor('primary-lighter')};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    @media (max-width: 991px) {
      padding: 0 0.75rem;

      flex-direction: column;

      width: calc(100vw - 40px);
    }
  `}
`

export const WrapperUnits = styled.div`
  ${({ theme }) => css`
    padding: 0rem 2rem;
    flex: 1;
    overflow: hidden;

    @media screen and (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 1rem 0 0.75rem;
    }
  `}
`

export const Unit = styled.button`
  ${buttonReset}
  cursor: pointer;
  display: flex;
  flex: 1;
  gap: 0.5rem;
  padding: 0.5rem 0.25rem;
  text-align: left;
  width: 100%;
`

export const WrapperTexts = styled.div`
  ${({ theme }) => css`
    overflow: hidden;

    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;

    @media screen and (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      width: 100%;
      width: calc(100vw - 40px);
    }
  `}
`

export const WrapperHeading = styled.div`
  ${({ theme }) => css`
    flex-basis: 175px;
    padding: 0rem 2rem;
    border-right: 1px solid ${theme.colors.getColor('neutral-light')};

    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;

    @media screen and (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding: 1rem 0;

      flex-basis: 76px;
      align-items: center;

      border-right: none;
      border-bottom: 1px solid ${theme.colors.getColor('neutral-light')};
    }
  `}
`

export const Line = styled.div`
  ${({ theme }) => css`
    width: 66px;
    height: 2px;
    margin-top: 1rem;
    background: ${theme.colors.getColor('neutral-dark')};
  `}
`

export const WrapperUnitNearbyPrivate = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.getColor('neutral-purewhite')};
    border-bottom: 4px solid ${theme.colors.getColor('primary-lighter')};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    flex-direction: column;
    margin-top: 1.5rem;
    padding: 1rem 0.75rem;

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      flex-direction: row;
    }
  `}
`

export const ContentUnitNearbyPrivate = styled.button`
  ${buttonReset}
  ${({ theme }) => css`
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    margin-top: 16px;
    padding: 8px 4px;
    text-align: left;
    max-width: 604px;

    :hover {
      opacity: 0.9;
    }

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      margin: 0;
      padding: 0 20px 0 32px;
    }
  `}
`

export const WrapperTitleUnitNearbyPrivate = styled.div`
  ${({ theme }) => css`
    padding-bottom: 16px;
    border-bottom: 1px solid ${theme.colors.getColor('neutral-light')};

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      border-bottom: initial;
      border-right: 1px solid ${theme.colors.getColor('neutral-light')};
      flex-basis: 175px;
      padding: 0 32px 0 20px;
    }
  `}
`

export const TitleUnitNearbyPrivate = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      align-items: flex-start;
    }

    &::after {
      background-color: ${theme.colors.getColor('neutral-dark')};
      content: '';
      height: 2px;
      width: 68px;
    }
  `}
`

export const ContentModalUnitNearbyPrivate = styled.div`
  ${({ theme }) => css`
    padding: 16px 32px;
    text-align: center;

    @media (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      max-width: 400px;
    }
  `}
`

export const TruncateAddress = styled.div`
  ${({ theme }) => css`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;

    @media screen and (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      width: 100%;
      text-align: left;
    }
  `}
`
